<template>
	<v-app id="inspire">
		<canvas ref="cvs"></canvas>
		<v-main>
			<v-container class="fill-height" fluid>
				<!-- <div class="image"
					style="position: absolute; left: 0; width:100%; background-color: blanchedalmond;">
				</div> -->
				<!-- <canvas></canvas> -->
				<v-row align="center" justify="center">
					<v-col cols="11" sm="6" md="4"  lg="3">
						<v-card class="elevation-12">
							<v-toolbar color="amber darken-4" dark flat>
								<v-toolbar-title>欢迎登录有课丫机构管理系统</v-toolbar-title>
								<v-spacer />
								<v-btn-toggle v-model="loginType" mandatory color="red" light>
									<v-btn><v-icon>mdi-cellphone</v-icon>手机号</v-btn>
									<v-btn><v-icon>mdi-account</v-icon>员工号</v-btn>
								</v-btn-toggle>
							</v-toolbar>
							<v-card-text>
								<v-form>
									<v-text-field label="手机号" type="number" v-if="loginType===0"
										prepend-icon="mdi-cellphone" v-model="loginAccount" />	
									<v-text-field label="员工号" type="number" v-if="loginType===1"
										prepend-icon="mdi-account" v-model="loginAccount" />
									<v-text-field label="密码" prepend-icon="mdi-lock" type="password"
										 v-model="loginPassword" />
								</v-form>
								<div v-if="error.show" class="d-flex justify-center">
									<span style="color:red">{{ error.msg }}</span>
								</div>
							</v-card-text>
							<v-card-actions>
								<v-spacer />
								<v-btn @click="login" color="amber darken-4 white--text">登录</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
				<v-dialog v-model="errorShow" width="500" persistent>
					<v-card>
						<v-card-title style="background-color: #BA68C8;">温馨提示</v-card-title>
						<v-card-text class="mt-3 d-flex flex-column align-center justify-center" style="height: 230px;">
							<span>请使用电脑登录,手机端可关注公众号“有课丫”登录</span>
							<!-- <div @touchstart="touchStart()" @touchend="touchEnd()">
								<v-img :src="qrcodeUrl" width="160" height="160"></v-img>
							</div> -->
							<v-img :src="qrcodeUrl" width="160" height="160"></v-img>
						</v-card-text>
					</v-card>
				</v-dialog>
				<!-- 页脚 -->
				<v-footer app class="flex-row justify-center">
					<div :span="24" class="bt-footer">
						<span>Copyright © 2022 长沙永芸信息科技有限公司 All Rights Reserved.</span>
						<span class="ml-4">ICP备案号：<a href="https://beian.miit.gov.cn" target="_blank">湘ICP备2022020124号-1</a></span>
					</div>
				</v-footer>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
	import utils from "../config/utils"
	import storage from "../config/storage"
	import global from "../config/global"
	import md5 from "js-md5"
	import rainCode from "../config/login.js"

	
	export default {
		data() {
			return {
				errorShow:false,
				loginType:0, // 0=手机号登录  1=员工号登录
				loginAccount:"",
				loginPassword:"",
				Loop:'', //  定时器
				qrcodeUrl:'https://photo.youkeya.cn/assets/icon/yky_gzh_qrcode.jpeg', // 后端返回的二维码图片路径
				error:{
					show:false,
					msg:""
				}
			}
		},
		created() {
			// document.title= "永芸信息";
			console.log(navigator.userAgent);
			//测试当前是哪个手机系统，可根据业务需要选择
			if(/Android|Windows Phone|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)){  
				this.errorShow =true;
				return;
				
			}else if(/iPad/i.test(navigator.userAgent)){ 
				console.log("pad端")   
			}

			const token = storage.getToken();
			if (token && token.token) {
				this.$router.push("/");
			}
			
			
			
		},
		mounted() {
			let cvs= this.$refs.cvs;
			rainCode(cvs);
		},
		methods: {
			login() {
				
				console.log(this.loginType);
				
				if (!this.loginAccount){
					this.$noty.error('账号不能为空');
					return
				}
				
				const that = this;
				this.axios.post("/basic/employee/login", {
					loginType:this.loginType===0?'mobile':'empNo',
					loginAccount: this.loginAccount,
					loginPassword:  md5(this.loginPassword),
					loginPlatForm: "PcWeb",
				}).catch(function(e) {
					
				}).then(function(res) {
					console.log(res);
					if (res && res.data) {
						console.log(">>>>>>>>>>>>登录返回>>>>>>>>>>>>");
						console.log(res.data);
						console.log(">>>>>>>>>>>>登录返回>>>>>>>>>>>>");
						if (res.data["code"] === 200) {
							storage.setToken(res.data["data"]["token"]);
							global.employee = res.data["data"]["employee"];
							global.routeTree = res.data["data"]["menuTree"];
							
							// 获取七牛的token
							utils.getUploadImgToken();
							
							// 默认第一个校区为当前校区
							const shopList = global.employee.shopList.length ? global.employee.shopList : global.employee.renewalShopList || [];
							if (shopList.length > 0){
								// 设置当前的校区
								storage.setCurrentShop(shopList[0]);
							}
							
							
							let path = "/home/index"
							that.$router.push(path);
							
						} else {
							that.$noty.error("登录失败:"+res.data["message"]);
							that.error.show = true;
							that.error.msg = res.data["message"];
						}
					}
				});
			},
			touchEnd() {
			  //手指离开
			  clearTimeout(this.Loop);
			},
			touchStart() {
				//手指触摸
				clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
				this.Loop = setTimeout(() => {
					this.downloadIamge(this.qrcodeUrl, "youkeya_qrcode");
				}, 1000);
			},
			downloadIamge(imgsrc, name) {
				//创建a对象
				const link = document.createElement('a')
				link.setAttribute('download', name)
				
				// 根据图片链接创建图片对象
				const image = new Image()
				// 添加时间戳，防止浏览器缓存图片
				image.src = imgsrc + '?timestamp=' + new Date().getTime()
				// 设置 crossOrigin 属性，解决图片跨域报错
				image.setAttribute('crossOrigin', 'Anonymous')
				image.onload = () => {
					//图片加载好以后 把图片转base64 设置到a的href 触发点击开始下载
					link.href = this.imageToBase64(image)
				    link.click()
				}
			},
			imageToBase64(image) {
				// image对象转base64
			    let canvas = document.createElement('canvas');
			    let width = image.width;
			    let height = image.height;
			
			    canvas.width = width
			    canvas.height = height
			    let context = canvas.getContext('2d')
			    context.drawImage(image, 0, 0, width, height)
			    return canvas.toDataURL('image/png')
			}

		
		}
	}
</script>

<style scoped>
	canvas {
	  position: absolute;
	  top: 0;
	  left: 0;
	  z-index: 0;
	  width: 100%;
	  height: 100vh;
	}
</style>